<div class="breadcrumb p-2 fx-row">
  <a routerLink="/" class="breadcrumb-item fx-row fx-justify-start" (click)="closeSubMenus()">
      <mat-icon>home</mat-icon>&nbsp;&nbsp;&nbsp;
      <span class="breadcrumb-title">Página Principal</span>
  </a>
  <div *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item fx-row fx-justify-start">
    <a (click)="nagivateTo(breadcrumb.url)">{{breadcrumb.name}}</a>
  </div>
</div>
